import { EventEmitter } from "@angular/core";
import { UnitModel } from "../../shared/models/unit.model";
import { ColumnModel } from "../../shared/models/column.model";

export class UnitBuildData{
    module = {
        name: "Unit",
        new_name: "unit",
        filtered_name:"Unit",
        has_dot_menu: true,
        icon:'fa-pray',
        permission:'unit'
    }
    
    onReload: EventEmitter < boolean > = new EventEmitter<boolean>();//Forces Reload of codeblack table on emit.
    rowFunction = (row:UnitModel) => {//Generates Row for codeblack-table
        return UnitModel.getListRow(row);
    }
    
    columns:ColumnModel[] = [
        {
            title: "Id",
            prop: "id",
            flex_grow: 1,
            row_accessor: "id",
            class:""//force-flex force-flex-end
        },
        {
            title: "Title",
            prop: "title",
            flex_grow: 4,
            row_accessor: "title",
        }
    ];

    constructor(){
        for(let col of this.columns){
            col = new ColumnModel(col);
        }
    }

}